import React from "react";
import { NextSeo } from "next-seo";
import { SectionsProvider } from "domains/inference/contexts/SectionsProvider";
import { JobSessionProvider } from "domains/jobs/contexts/JobSessionProviderV2";
import CreateBlend from "domains/models/components/Blend/BlendCreation";
import { CreateBlendProvider } from "domains/models/contexts/CreateBlendProvider";

function BlendNew() {
  return (
    <>
      <NextSeo title="New Composition" />

      <CreateBlendProvider>
        <SectionsProvider>
          <JobSessionProvider
            isEmptySessionStart
            forcedFilterTypeValues={["image:inference"]}
            forcedFilterAuthorValue="me"
          >
            <CreateBlend />
          </JobSessionProvider>
        </SectionsProvider>
      </CreateBlendProvider>
    </>
  );
}

export default BlendNew;
